import React from "react";
import {Image} from 'react-bootstrap'

import "./ServiceCategory.css";

import service_category from "../../asset/images/service_category.webp";
import energy_saving from "../../asset/images/energy_saving.png";
import btn_01 from "../../asset/images/btn-01.svg";

// 服务范畴
class ServiceCategory extends React.Component {
  render() {
    return (
      <div className="service">
        <Image className="service_ico" src={service_category} fluid />
        <div className="service_content">
          <div className="service_img">
            <Image src={energy_saving} />
          </div>
          <div className="service_right">
            <span className="service_title">工业节能领域技术应用</span>
            <div className="server_block"></div>
            <p>
              适用于动力系统，包含空压系统，中央空调系统，工艺循环水系统，供热系统等。<br/>
              综合应用设计优化、高效设备定制、寻优控制、在线诊断，数字化运维等多种优化手段。<br/>
              大幅提升动力系统能效、可靠性、智能化程度，降低用能成本。<br/>
            </p>
            <div className="service_tag">
              <div className="tag">
                <span>粮油加工</span>
              </div>
              <div className="tag">
                <span>金属冶炼</span>
              </div>
              <div className="tag">
                <span>能源供应</span>
              </div>
              <span>... ...</span>
            </div>
            <Image className="index_btn_1" src={btn_01} />
          </div>
        </div>
      </div>
    )
  }
}

export default ServiceCategory
